export default __webpack_public_path__ + "images/models/93282b959dc978b16cf23f8f7cafc485.glb";